import type { 
  TranslationModelsResponse, 
  TranslationResponse, 
  BatchTranslationResponse, 
  TranslationOptions 
} from '~/types/translation'

export const useTranslation = {
  // Get available translation models
  async getModels(): Promise<TranslationModelsResponse> {
    const api = useAPI()
    const data = await api.get('/translate/models')
    return data as TranslationModelsResponse
  },

  // Translate a single text
  async translate(text: string, options?: TranslationOptions): Promise<TranslationResponse> {
    const api = useAPI()
    const data = await api.post('/translate', {
      body: {
        text,
        sourceLanguage: options?.sourceLanguage || 'Chinese',
        targetLanguage: options?.targetLanguage || 'English',
        customPrompt: options?.customPrompt,
        model: options?.model
      }
    })
    return data as TranslationResponse
  },

  // Batch translate multiple texts
  async translateBatch(
    texts: { key: string; text: string }[], 
    options?: TranslationOptions
  ): Promise<BatchTranslationResponse> {
    const api = useAPI()
    const data = await api.post('/translate/batch', {
      body: {
        texts,
        sourceLanguage: options?.sourceLanguage || 'Chinese',
        targetLanguage: options?.targetLanguage || 'English',
        customPrompt: options?.customPrompt,
        model: options?.model
      }
    })
    return data as BatchTranslationResponse
  }
}